import api from 'services/api';

/**
 * DELETE `/triggers/:trigger_id`. Resolves on success; throws on HTTP error (404
 * for an unknown trigger, 403 without `triggers.delete`), which the caller
 * surfaces. The 200 body is a `{ message }` acknowledgement naming the deleted
 * trigger — nothing load-bearing, so there is nothing to validate or return.
 *
 * The id is numeric, so unlike the path-addressed resources (locks, scheduling
 * windows — whose names may contain a `/`) there is no segment to escape.
 */
export const deleteTrigger = async (id: number): Promise<void> => {
  await api.delete(`/triggers/${id}`);
};
